import { addToDictionary } from '../../../i18n/index.js';
import { dictionary as dictionary_en } from './en/index.js';
const dictionaries = {
    en: dictionary_en,
    ca: dictionary_en,
    de: dictionary_en,
    es: dictionary_en,
    fr: dictionary_en,
    it: dictionary_en,
    nl: dictionary_en,
    pt: dictionary_en,
};
Object.entries(dictionaries).forEach(entry => {
    const dictionary = addToDictionary(entry[0], entry[1]);
});
